import { NotificationsActiveRounded } from "@mui/icons-material";
import {
  Avatar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Notification = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [notifs, setNotifs] = useState([]);
  const { branch, setLoader } = useContext(AppContext);

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Notif + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res &&
            res.status === 200 &&
            setNotifs([
              ...res.result.filter(
                (j) =>
                  moment(j.createDate, "MM/DD/YYYY").format("MM/YYYY") ===
                  moment().format("MM/YYYY")
              ),
            ]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const handleView = (id) => {
    navigate(`/view_member_profile/${id}`);
  };
  return (
    <Paper sx={{ padding: { xs: "10px", md: "15px" } }}>
      <h2 className="fs-18 tx-upp gray-color fw-4 m-0 d-flex">
        <NotificationsActiveRounded color="primary" /> &nbsp;&nbsp;{" "}
        {t("Notification")}
      </h2>

      <TableContainer
        className="mt-30 pr-10"
        sx={{ height: "300px", overflow: "auto" }}
      >
        <Table size="small">
          <TableBody>
            {notifs.map((notif, i) => (
              <TableRow hover key={i}>
                <TableCell>
                  <Avatar src={notif.member.photo} className="shadow-md" />
                </TableCell>
                <TableCell sx={{ minWidth: "100px" }}>
                  <div className="d-grid">
                    <span
                      className="fw-5 fs-16 primary-color c-pointer"
                      onClick={() => handleView(notif.member.id)}
                    >
                      {notif.member.firstName + " " + notif.member.lastName}
                    </span>
                    <span className="fs-12 fw-4 grayMD-color c-pointer">
                      {notif.createDate}
                    </span>
                  </div>
                </TableCell>
                <TableCell sx={{ minWidth: "300px" }}>
                  <span className="fw-4 fs-16 gray-color ">{notif.msg}</span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default Notification;
